'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var EventEmitter = require('events').EventEmitter;
/**
 * Interface for OrbitDB Access Controllers
 *
 * Any OrbitDB access controller needs to define and implement
 * the methods defined by the interface here.
 */


var AccessController = /*#__PURE__*/function (_EventEmitter) {
  _inherits(AccessController, _EventEmitter);

  var _super = _createSuper(AccessController);

  function AccessController() {
    _classCallCheck(this, AccessController);

    return _super.apply(this, arguments);
  }

  _createClass(AccessController, [{
    key: "type",
    get:
    /*
      Return the type for this controller
      NOTE! This is the only property of the interface that
      shouldn't be overridden in the inherited Access Controller
    */
    function get() {
      return this.constructor.type;
    }
    /* Each Access Controller has some address to anchor to */

  }, {
    key: "address",
    get: function get() {}
    /*
      Called by the databases (the log) to see if entry should
      be allowed in the database. Return true if the entry is allowed,
      false is not allowed
    */

  }, {
    key: "canAppend",
    value: function () {
      var _canAppend = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(entry, identityProvider) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function canAppend(_x, _x2) {
        return _canAppend.apply(this, arguments);
      }

      return canAppend;
    }()
    /* Add and remove access */

  }, {
    key: "grant",
    value: function () {
      var _grant = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(access, identity) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", false);

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function grant(_x3, _x4) {
        return _grant.apply(this, arguments);
      }

      return grant;
    }()
  }, {
    key: "revoke",
    value: function () {
      var _revoke = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(access, identity) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", false);

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function revoke(_x5, _x6) {
        return _revoke.apply(this, arguments);
      }

      return revoke;
    }()
    /* AC creation and loading */

  }, {
    key: "load",
    value: function () {
      var _load = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(address) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function load(_x7) {
        return _load.apply(this, arguments);
      }

      return load;
    }()
    /* Returns AC manifest parameters object */

  }, {
    key: "save",
    value: function () {
      var _save = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function save() {
        return _save.apply(this, arguments);
      }

      return save;
    }()
    /* Called when the database for this AC gets closed */

  }, {
    key: "close",
    value: function () {
      var _close = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function close() {
        return _close.apply(this, arguments);
      }

      return close;
    }()
  }], [{
    key: "create",
    value:
    /*
      Every AC needs to have a 'Factory' method
      that creates an instance of the AccessController
    */
    function () {
      var _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(orbitdb, options) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function create(_x8, _x9) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
    /* Return the type for this controller */

  }, {
    key: "type",
    get: function get() {
      throw new Error('\'static get type ()\' needs to be defined in the inheriting class');
    }
  }]);

  return AccessController;
}(EventEmitter);

module.exports = AccessController;